import { Typography } from '@mui/material'
import FormattedAgentText from '../FormattedAgentText'
import StreamingText from '../StreamingText'

const LEVEL_FONT = {
  1: 'var(--app-agent-result-title-size)',
  2: 'var(--app-agent-result-title-size)',
  3: 'var(--app-agent-result-title-size)',
}

const Heading = ({ children, level = 3, streaming = false }) => {
  const content = typeof children === 'string' ? children : String(children ?? '')
  const fontSize = LEVEL_FONT[level] ?? LEVEL_FONT[3]

  const sx = {
    m: 0,
    my: '8px',
    color: 'text.primary',
    fontFamily: 'var(--app-font-sans)',
    fontSize,
    fontWeight: 'var(--app-agent-result-font-weight-medium)',
    lineHeight: 'var(--app-agent-result-line-height, 1.2)',
    whiteSpace: 'pre-wrap',
  }

  if (streaming) {
    return (
      <Typography component="p" variant="body2" sx={sx} aria-busy="true">
        <StreamingText component="span" text={content} showCaret formatted streaming />
      </Typography>
    )
  }

  if (!content.trim()) return null

  return (
    <Typography component="p" variant="body2" sx={sx}>
      <FormattedAgentText text={content} />
    </Typography>
  )
}

export default Heading
